export default {
  name: 'PcDisclaimerIcon',
  data() {
    return {
      className: 'app__disclaimer__icon',
    };
  },
  props: {
    image: {
      type: String,
      default: '',
    },
    imgAlt: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    linkTitle: {
      type: String,
      default: '',
    },
  },
  computed: {
    hasLink() {
      return !!this.link.length;
    },
    containerEl() {
      return this.hasLink ? 'a' : 'div';
    },
    linkTitleText() {
      return this.hasLink ? this.linkTitle : '';
    },
    linkUrl() {
      return this.hasLink ? this.link : '';
    },
  },
};
